import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import authReducer from '../features/auth/authSlice'
import projectsReducer from '../features/projects/projectsSlice'
import vehicleGroupingsReducer from '../features/groupings/vehicleGroupingsSlice'
import chargerGroupingsReducer from '../features/groupings/chargerGroupingsSlice'
import optimizeReducer from '../features/optimize/optimizeSlice'
import projectDataEntryProgressReducer from '../features/projectDataEntryProgress/projectDataEntryProgressSlice'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import componentsReducer from '../features/energySystem/componentsSlice'
import usersReducer from '../features/users/usersSlice'
import SecureAuthTransform from '../features/auth/secureAuthTransform'

const persistConfig = {
    key: 'root',
    storage,
    transforms: [SecureAuthTransform]
}

const persistedReducer = persistReducer(persistConfig, authReducer)

export const store = configureStore({
    reducer: {
        auth: persistedReducer,
        projects: projectsReducer,
        optimize: optimizeReducer,
        vehicleGroupings: vehicleGroupingsReducer,
        chargerGroupings: chargerGroupingsReducer,
        projectDataEntryProgress: projectDataEntryProgressReducer,
        components: componentsReducer,
        users: usersReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export const persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>
